import React from 'react';
import LoginForm from './LoginForm.tsx';
import { motion } from 'framer-motion';

const Login = () => {
  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <motion.div
        className="card shadow p-4 w-100"
        style={{ maxWidth: '500px' }}
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <div className="card-body">
          <h1 className="card-title text-center text-primary mb-4">Welcome to Access Management Portal</h1>
          <LoginForm />
        </div>
      </motion.div>
    </div>
  );
};

export default Login;
